import AssistantIcon from '@material-ui/icons/Assistant';
import { CustomBreadcrumbs, CustomList } from 'candy-commons-components';
import React from 'react';
import { TextField, TextInput, useTranslate } from 'react-admin';
import DynamoPagination from '../../components/DynamoPagination';
import CustomDatagrid from '../../components/organisms/customDatagrid';
const EnergyProviderList = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.energy-provider.name'),
            url: '',
            icon: <AssistantIcon />,
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <CustomList
                exporter={false}
                perPage={25}
                {...props}
                pagination={<DynamoPagination resource="energy-provider" />}
                // filters={<AssistanceFilter />}
                bulkActionButtons={
                    permissions &&
                    permissions['energy-provider'] &&
                    permissions['energy-provider'].delete
                }
            >
                <CustomDatagrid selectable rowClick="edit">
                    <TextField source="id" />
                    <TextField source="deepLink" />
                    <TextField source="appName" />
                </CustomDatagrid>
            </CustomList>
        </>
    );
};
export default EnergyProviderList;
